import _objectSpread from "/Users/fangyu/Code/unifygama/metacrm/metadesk-frontend/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _objectWithoutProperties from "/Users/fangyu/Code/unifygama/metacrm/metadesk-frontend/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
const _excluded = ["address", "signature", "message", "primaryType", "types", "domain"];
import { hashTypedData } from '../../utils/signature/hashTypedData.js';
import { verifyHash } from './verifyHash.js';
/**
 * Verify that typed data was signed by the provided address.
 *
 * - Docs {@link https://viem.sh/docs/actions/public/verifyTypedData.html}
 *
 * @param client - Client to use.
 * @param parameters - {@link VerifyTypedDataParameters}
 * @returns Whether or not the signature is valid. {@link VerifyTypedDataReturnType}
 */
export async function verifyTypedData(client, _ref) {
  let {
      address,
      signature,
      message,
      primaryType,
      types,
      domain
    } = _ref,
    callRequest = _objectWithoutProperties(_ref, _excluded);
  const hash = hashTypedData({
    message,
    primaryType,
    types,
    domain
  });
  return verifyHash(client, _objectSpread({
    address,
    hash,
    signature
  }, callRequest));
}
//# sourceMappingURL=verifyTypedData.js.map